export const GIFTCARD = 'FORM/GIFTCARD';
export const PRIVATE_EVENT = 'FORM/PRIVATE_EVENT';
export const MEMBER_FORM = 'FORM/MEMBER_FORM';
export const CONTACTUS_FORM = 'FORM/CONTACTUS_FORM';